import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, HostBinding, Inject, OnInit, Output, ViewChild, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Observable, Subject, map, retry, timer } from "rxjs";
import { NGXLogger } from "ngx-logger";
import { DOCUMENT } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { Stats } from "src/app/models/stats.model";


import { UtentiService } from "src/app/services/utenti.service";
import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { StatsService } from "src/app/services/notification.service";
import { ImpreseService } from "src/app/services/imprese.service";
import { CacheService } from "src/app/services/cache.service";

export let applicationVersionFromHome: string = "";

import * as Leaflet from "leaflet";

import { PraticaScuola_Firestore } from "src/app/models/praticaScuolaFirestore.model";
import { onSnapshot } from "firebase/firestore";
import { TabViewChangeEvent } from "primeng/tabview";
import { environment } from "src/environments/environment";
import { PraticaSanita_Firestore } from "src/app/models/praticaSanitaFirestore.model";
import { StatsFlowdy2 } from "src/app/models/statsFlowdy2.model";

Leaflet.Icon.Default.imagePath = "assets/leaflet/images/";

declare const CSVBoxImporter: any;

@Component({
  templateUrl: "./home.flowdy2.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeFlowdy2Component implements OnInit, AfterViewInit {
  ruolo: string = "";
  nome: string = "";
  isLoading: boolean = true;
  isDashboardLoading: boolean = true;
  isAdmin:      boolean = false;
  isSuperAdmin: boolean = false;
  
  isDipendente: boolean = true;
  hasBando1: boolean = false;
  hasBando2: boolean = false;
  hasSanita: boolean = false;
  
  isAzienda : boolean = false;
  isPresidioTIM : boolean = false;
  isPresidioSF : boolean = false;
  isDirigenteFirmaVerbali: boolean = false;
  isDirigenteFirmaPacchetti: boolean = false;
  isPM: boolean = false;
  isContabile: boolean = false;
  isDemo: boolean = false;
  bando: number = 0;
  activeTabType: string = "";

  protected stats:StatsFlowdy2;

  protected praticheBando1Totali = 100;
  protected praticheBando1InLavorazione = 20;

  protected praticheBando2Totali = 200;
  protected praticheBando2InLavorazione = 40;
  protected idImpresa:number;

  ragioneSocialeAzienda: string = "";

  protected lastPraticheSanita:PraticaScuola_Firestore[]=[];
  protected lastPraticheSanitaPerAzienda:PraticaScuola_Firestore[]=[];

  protected selectedPratica:PraticaScuola_Firestore;
  private collection_pratiche_scuola:string = environment.firebase.collection_pratiche_scuola;
  private collection_pratiche_sanita:string = environment.firebase.collection_pratiche_sanita;

  private selectedTabID:number =0; 

  @ViewChild("ultimePraticheSanitaDT", { static: true }) ultimePraticheSanitaDT: any;

  isLoggedIn: boolean = false;
  scuoleLoaded: boolean = false;
  sanitaLoaded: boolean = false;

  applicationVersion: string = "";
  contatore: number = 0;
  ref: DynamicDialogRef;

  //CSV BOX
  private csvbox_licenseKey_aggiornaPratiche:string=environment.csvBox.secret_aggiornaPratiche;
  private csvbox_licenseKey_aggiornaPraticheBando1:string=environment.csvBox.secret_aggiornaPraticheBando1;
  private csvbox_licenseKey_aggiornaPraticheSanita:string=environment.csvBox.secret_aggiornaPraticheSanita;
  private csvbox_user:string=environment.csvBox.user;
  private csvbox_importer_aggiornaPratiche:any;
  private csvbox_importer_aggiornaPraticheBando1:any;
  private csvbox_importer_aggiornaPraticheSanita:any;

  @Output() notificaCambioDatiEvent = new EventEmitter<string>();

  activeTabIndex: number = 0;
  private pendingTabIndex: number | null = null;
  private isComingFromWIP: boolean = false; // Flag per identificare arrivo da WIP
  
  constructor(
    public auth: AuthService,
    private http: HttpClient,
    private messageService: MessageService,
    private dipendenteService: UtentiService,
    private impreseService: ImpreseService,
    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    private router: Router,
    private route: ActivatedRoute,
    public firestore: AngularFirestore,
    private statsService: StatsService,
    private cacheService: CacheService,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  ngOnInit() {
    this.logger.info("[HOME] ON INIT");
    
    // Prima legge i query parameters e memorizza il tab da selezionare
    this.readTabSelectionFromQueryParams();
    
    // Carica prima i dati dal localStorage se disponibili per un rendering più veloce
    this.loadFromLocalStorage();
    
    this.auth.user$.subscribe((user) => {
      if (user != null) {
        this.handleUserAuthenticated(user);
      } else {
        this.handleUserNotAuthenticated();
      }
    });
  }

    private readTabSelectionFromQueryParams() {
     //this.logger.info("[HOME] readTabSelectionFromQueryParams");
     // Legge i query parameters per determinare quale tab selezionare
     this.route.queryParams.subscribe(params => {
       const bando = params['bando'];
       const from = params['from'];
       
       if (from && bando) {
         this.logger.info("[HOME] from: "+ from + " bando: "+ bando);
         
         // Mappa i parametri agli indici dei tab e memorizza per applicare dopo
         let targetTabIndex = 0; // Default alla dashboard
         if(from === 'WIP_SOPRALLUOGHI'){
           targetTabIndex = 6; // Tab WIP
           this.bando = bando;
           this.activeTabType = 'SOPRALLUOGHI';
           this.isComingFromWIP = true; // Imposta il flag per evitare caricamento dashboard
         }else if(from === 'WIP_APPUNTAMENTI'){
          targetTabIndex = 6; // Tab WIP
          this.bando = bando;
          this.activeTabType = 'APPUNTAMENTI';
          this.isComingFromWIP = true; // Imposta il flag per evitare caricamento dashboard
         }else if(from === 'DOCS_FASE1'){
          targetTabIndex = 7; // Tab WIP
          this.bando = bando;
          this.activeTabType = 'DOCS_FASE1';
          this.isComingFromWIP = true; // Imposta il flag per evitare caricamento dashboard
         }else if(from === 'DOCS_FASE2'){ 
          targetTabIndex = 7; // Tab WIP
          this.bando = bando;
          this.activeTabType = 'DOCS_FASE2';
          this.isComingFromWIP = true; // Imposta il flag per evitare caricamento dashboard
         }else if(from === 'DOCS_FASE3'){ 
          targetTabIndex = 7; // Tab WIP
          this.bando = bando;
          this.activeTabType = 'DOCS_FASE3';
          this.isComingFromWIP = true; // Imposta il flag per evitare caricamento dashboard
         }
         this.pendingTabIndex = targetTabIndex;
         //this.logger.info(`[HOME] Tab memorizzato per applicazione successiva: ${targetTabIndex}`);
         
         // Rimuove i query parameters
         setTimeout(() => {
           this.router.navigate([], {
             relativeTo: this.route,
             queryParams: {},
             replaceUrl: true
           });
         }, 100);
       }
     });
   }

  private loadFromLocalStorage() {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn === "true") {
      this.isLoggedIn = true;
      this.isAzienda = localStorage.getItem("isAzienda") === "true";
      this.idImpresa = parseInt(localStorage.getItem("idAzienda")) || 0;
      this.ragioneSocialeAzienda = localStorage.getItem("ragioneSocialeAzienda") || "";
      this.setUserRoles();
      this.isLoading = false;
      this.isDashboardLoading = false;
    }
  }

  private handleUserAuthenticated(user: any) {
    // Ritarda l'inizializzazione di CSVBox per migliorare il caricamento iniziale
    setTimeout(() => this.initCSVBox(), 1000);
    
    if (!localStorage.getItem("token") || localStorage.getItem("token") === 'null') {
      this.auth.getAccessTokenSilently().subscribe((token) => {
        localStorage.setItem("token", token);
        this.isDashboardLoading = false;
      });
    } else {
      this.isDashboardLoading = false;
    }

    if (!this.userService.getUser()) {
      this.loadUserData(user);
    } else {
      this.setUserFromLocalStorage();
    }
    
    this.isLoading = false;
    this.isLoggedIn = true;
    this.nome = user.name;
  }

  private handleUserNotAuthenticated() {
    this.logger.info('[HOME] userService getUser NON NULLO');
    this.setUserRoles();
  }

  private loadUserData(user: any) {
    const userKey = `user_${user.sub}`;
    const cachedUser = this.cacheService.get(userKey);
    
    if (cachedUser) {
      this.userService.setUser(cachedUser);
      this.setUserDataFromCached(cachedUser);
      return;
    }

    this.retryApiCall(
      () => this.dipendenteService.getByIdAuth0(user.sub.slice(user.sub.indexOf('|') + 1)),
      3,
      1000
    ).subscribe({
      next: (utente) => {
        this.userService.setUser(utente);
        this.cacheService.set(userKey, utente, 30 * 60 * 1000); // Cache per 30 minuti
        this.setUserDataFromResponse(utente);
        
        if (this.userService.isAzienda) {
          this.handleAziendaUser(utente);
        } else {
          this.handleNonAziendaUser();
        }
      },
      error: (error) => {
        this.logger.error('Errore nel caricamento dati utente:', error);
        this.messageService.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Errore nel caricamento dati utente. Riprova più tardi.',
          life: 5000
        });
        // Fallback ai dati del localStorage se disponibili
        this.setUserFromLocalStorage();
      }
    });
  }

  private setUserDataFromCached(utente: any) {
    if (utente.azienda) {
      this.ragioneSocialeAzienda = utente.azienda.ragioneSociale;
      this.idImpresa = utente.azienda.id;
    }
    this.setUserRoles();
  }

  private setUserDataFromResponse(utente: any) {
    this.ragioneSocialeAzienda = utente.azienda.ragioneSociale;
    this.idImpresa = utente.azienda.id;
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("ruolo", this.userService.getUser().ruolo.codice.toString());
    localStorage.setItem("idAzienda", this.userService.getUser().azienda.id.toString());
    localStorage.setItem("ragioneSocialeAzienda", utente.azienda.ragioneSociale);
    localStorage.setItem("idUtente", utente.id);
  }

  private handleAziendaUser(utente: any) {
    localStorage.setItem("isAzienda", "true");
    this.isAzienda = true;
    
    // Controlla prima se i bandi sono in cache
    const cacheKey = `bandi_${utente.azienda.id}`;
    const cachedBandi = this.cacheService.get(cacheKey);
    
    if (cachedBandi) {
      this.processBandi(cachedBandi);
    } else {
      // Lazy load dei bandi per non bloccare il rendering iniziale
      setTimeout(() => {
        this.cacheService.cacheObservable(
          cacheKey,
          this.impreseService.getBandi(utente.azienda.id),
          10 * 60 * 1000 // Cache per 10 minuti
        ).subscribe(bandi => {
          this.processBandi(bandi);
        });
      }, 100);
    }
  }

  private processBandi(bandi: any[]) {
    bandi.forEach(bando => {
      if (bando.denominazione === 'BANDO 1') {
        localStorage.setItem("BANDO_1", "true");
        this.hasBando1 = true;
        // Carica le stats in background con throttling - solo se non si arriva da WIP
        if (!this.isComingFromWIP) {
          setTimeout(() => {
            this.loadStatsWithThrottling(
              () => this.loadStatsBando1PerAzienda(localStorage.getItem("idAzienda")),
              'bando1_stats'
            );
          }, 500);
        } else {
          this.logger.info("[HOME] Caricamento stats Bando 1 saltato - arrivo da WIP");
        }
      } else if (bando.denominazione === 'BANDO 2') {
        localStorage.setItem("BANDO_2", "true");
        this.hasBando2 = true;
        // Carica le stats in background con throttling - solo se non si arriva da WIP
        if (!this.isComingFromWIP) {
          setTimeout(() => {
            this.loadStatsWithThrottling(
              () => this.loadStatsBando2PerAzienda(localStorage.getItem("idAzienda")),
              'bando2_stats'
            );
          }, 700);
        } else {
          this.logger.info("[HOME] Caricamento stats Bando 2 saltato - arrivo da WIP");
        }
      }
    });
  }

  private handleNonAziendaUser() {
    this.isAzienda = false;
    this.setUserRoles();
    localStorage.setItem("isAzienda", "false");
  }

  private setUserFromLocalStorage() {
    this.isAzienda = localStorage.getItem("isAzienda") === "true";
    this.idImpresa = parseInt(localStorage.getItem("idAzienda"));
    this.setUserRoles();
  }

  private setUserRoles() {
    const ruolo = localStorage.getItem("ruolo");
    const roleMap = {
      'ADMIN': () => this.isAdmin = true,
      'SUPERADMIN': () => this.isSuperAdmin = true,
      'PRESIDIO': () => this.isPresidioTIM = true,
      'SMARTFIBER': () => this.isPresidioSF = true,
      'DIRIGENTE_FIRMA_VERBALI': () => this.isDirigenteFirmaVerbali = true,
      'DIRIGENTE_FIRMA_PACCHETTI': () => this.isDirigenteFirmaPacchetti = true,
      'PM': () => this.isPM = true,
      'CONTABILE': () => this.isContabile = true,
      'DEMO': () => this.isDemo = true
    };
    
    if (ruolo && roleMap[ruolo]) {
      roleMap[ruolo]();
    }
  }

  aggiornaPratiche(bando:number){
    
  }
  
  onTabChange(event: TabViewChangeEvent) {
    this.isLoading = false;
    this.activeTabIndex = event.index;
    const selectedTabId = event.index;
    this.selectedTabID = selectedTabId;
    
    // Reset del flag WIP dopo la prima navigazione
    if (this.isComingFromWIP) {
      this.isComingFromWIP = false;
      this.logger.info("[HOME] Flag WIP resettato dopo cambio tab");
    }
    
    // Inizializza il contenuto del tab solo quando viene selezionato
    this.initializeTabContent(event.index);
  }

  private initializeTabContent(tabIndex: number) {
    // Precarica il contenuto del tab solo quando necessario
    switch (tabIndex) {
      case 0:
        // Dashboard - caricata automaticamente, solo se non si arriva da WIP
        if (!this.isComingFromWIP) {
          // I dati della dashboard vengono caricati automaticamente durante l'inizializzazione
          this.logger.info("[HOME] Caricamento dati dashboard permesso");
        } else {
          this.logger.info("[HOME] Caricamento dati dashboard saltato - arrivo da WIP");
        }
        break;
      case 1:
        // Fase I - carica on demand
        this.loadFase1Data();
        break;
      case 2:
        // ProntoFibra - carica on demand
        this.loadProntoFibraData();
        break;
      case 3:
        // Fase II - carica on demand
        this.loadFase2Data();
        break;
      case 4:
        // Fase III - carica on demand
        this.loadFase3Data();
        break;
      case 5:
        // KO - carica on demand
        this.loadKOData();
        break;
      case 6:
        // WIP - carica on demand
        this.loadWIPData();
        break;
      case 7:
        // Docs - carica on demand
        this.loadDocsData();
        break;
      case 8:
        // Overall - carica on demand
        this.loadOverallData();
        break;
    }
  }

  private loadFase1Data() {
    // Implementa lazy loading per Fase 1
    if (!this.isDataLoaded('fase1')) {
      // Logica di caricamento dati
      this.markDataAsLoaded('fase1');
    }
  }

  private loadProntoFibraData() {
    // Implementa lazy loading per ProntoFibra
    if (!this.isDataLoaded('prontofibra')) {
      // Logica di caricamento dati
      this.markDataAsLoaded('prontofibra');
    }
  }

  private loadFase2Data() {
    // Implementa lazy loading per Fase 2
    if (!this.isDataLoaded('fase2')) {
      // Logica di caricamento dati
      this.markDataAsLoaded('fase2');
    }
  }

  private loadFase3Data() {
    // Implementa lazy loading per Fase 3
    if (!this.isDataLoaded('fase3')) {
      // Logica di caricamento dati
      this.markDataAsLoaded('fase3');
    }
  }

  private loadKOData() {
    // Implementa lazy loading per KO
    if (!this.isDataLoaded('ko')) {
      // Logica di caricamento dati
      this.markDataAsLoaded('ko');
    }
  }

  private loadWIPData() {
    // Implementa lazy loading per WIP
    if (!this.isDataLoaded('wip')) {
      // Logica di caricamento dati
      this.markDataAsLoaded('wip');
    }
  }

  private loadDocsData() {
    // Implementa lazy loading per Docs
    if (!this.isDataLoaded('docs')) {
      // Logica di caricamento dati
      this.markDataAsLoaded('docs');
    }
  }

  private loadOverallData() {
    // Implementa lazy loading per Overall
    if (!this.isDataLoaded('overall')) {
      // Logica di caricamento dati
      this.markDataAsLoaded('overall');
    }
  }

  private isDataLoaded(dataType: string): boolean {
    return localStorage.getItem(`${dataType}_loaded`) === 'true';
  }

  private markDataAsLoaded(dataType: string) {
    localStorage.setItem(`${dataType}_loaded`, 'true');
  }

  initCSVBox(){
    this.csvbox_importer_aggiornaPratiche = new CSVBoxImporter(this.csvbox_licenseKey_aggiornaPratiche, {
    }, (result: boolean, data: any) => {
      if (result) {
        this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche AGGIORNATE con successo!', life:10000});
      } else {
        this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di AGGIORNAMENTO delle pratiche', life:10000});
      }
    });

    this.csvbox_importer_aggiornaPratiche.setUser({
      user_id: "default123"
    });
    this.csvbox_importer_aggiornaPratiche.language="it";

    this.csvbox_importer_aggiornaPraticheSanita = new CSVBoxImporter(this.csvbox_licenseKey_aggiornaPraticheSanita, {
      // Configuration options
    }, (result: boolean, data: any) => {
      if (result) {
        this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche AGGIORNATE  con successo!', life:10000});
      } else {
        this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di MODIFICA delle pratiche', life:10000});
        // Custom code
      }
    });

    this.csvbox_importer_aggiornaPraticheSanita.setUser({
      user_id: "default123"
    });
    this.csvbox_importer_aggiornaPraticheSanita.language="it"; 

    this.csvbox_importer_aggiornaPraticheBando1 = new CSVBoxImporter(this.csvbox_licenseKey_aggiornaPraticheBando1, {
    }, (result: boolean, data: any) => {
      if (result) {
        this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche AGGIORNATE con successo!', life:10000});
      } else {
        this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di AGGIORNAMENTO delle pratiche', life:10000});
      }
    });

    this.csvbox_importer_aggiornaPraticheBando1.setUser({
      user_id: "default123"
    });
    this.csvbox_importer_aggiornaPraticheBando1.language="it";

  }



  getStatoClass(status: string): string {
    if (status === "CARICATA") {
      return "stato-pratica-caricata";
    }else if (status === "ASSEGNATA") {
      return "stato-pratica-assegnata";
    } else if (status === "IN PROGETTAZIONE") {
      return "stato-pratica-inprogettazione";
    } else if (status === "IN CARICO IMPRESA") {
      return "stato-pratica-incarico";
    } else if (status === "CONSEGNATA") {
      return "stato-pratica-consegnata";
    } else if (status === "IN REWORK AZIENDA") {
      return "stato-pratica-inrework";
    }else if (status === "IN VERIFICA SMARTFIBER") {
      return "stato-pratica-inrework-presidio";
    }else if (status === "IN FIRMA") {
      return "stato-pratica-inFirma";
    }else if (status === "IN CARICO PRESIDIO") {
      return "stato-pratica-incarico-tim";
    }else if (status === "APPROVATA") {
      return "stato-pratica-approvata";
    }else if (status === "RESPINTA") {
      return "stato-pratica-respinta";
    }else if (status === "ANNULLATA") {
      return "stato-pratica-annullata";
    }
    return "";
  }


    ngAfterViewInit() {
    // Applica la selezione del tab se presente dai query parameters
    if (this.pendingTabIndex !== null) {
      //this.logger.info(`[HOME] Tentativo di applicare tab: ${this.pendingTabIndex}`);
      setTimeout(() => {
        const oldIndex = this.activeTabIndex;
        this.activeTabIndex = this.pendingTabIndex!;
       // this.logger.info(`[HOME] Tab cambiato da ${oldIndex} a ${this.activeTabIndex}`);
        
        // Carica solo i dati del tab selezionato se si arriva da WIP
        if (this.isComingFromWIP) {
         // this.logger.info(`[HOME] Caricamento dati solo per tab WIP (${this.activeTabIndex})`);
          this.initializeTabContent(this.activeTabIndex);
        }
        
        this.cdr.detectChanges();
        this.pendingTabIndex = null;
      }, 100);
    }

    // Preload intelligente dopo che la vista è stata inizializzata - solo se non si arriva da WIP
    if (!this.isComingFromWIP) {
      setTimeout(() => {
        this.intelligentPreload();
      }, 2000);
    }
  }

  private intelligentPreload() {
    // Precarica i dati per i tab più frequentemente utilizzati
    if (this.isAzienda) {
      // Per le aziende, precarica Fase I e Fase II
      this.preloadTabData(1); // Fase I
      setTimeout(() => this.preloadTabData(3), 1000); // Fase II dopo 1 secondo
    } else if (this.isAdmin || this.isSuperAdmin) {
      // Per gli admin, precarica Overall e Dashboard avanzata
      this.preloadTabData(8); // Overall
    }
  }

  private preloadTabData(tabIndex: number) {
    if (tabIndex !== this.activeTabIndex) {
      this.initializeTabContent(tabIndex);
    }
  }

  /**
   * Metodo per ottimizzare la gestione delle statistiche con throttling
   */
  private loadStatsWithThrottling(loadFunction: () => void, key: string) {
    const lastLoaded = this.cacheService.get(`last_loaded_${key}`);
    const now = Date.now();
    
    // Throttling: non ricaricare se caricato negli ultimi 30 secondi
    if (!lastLoaded || (now - lastLoaded) > 30000) {
      loadFunction();
      this.cacheService.set(`last_loaded_${key}`, now, 60000); // Cache per 1 minuto
    }
  }

    openPagina(){

    }
    openPraticaSanita(pratica:PraticaSanita_Firestore){
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-sanita/pratica/'+pratica.codiceInfratel]));
    }
    
    loadStatsBando1PerAzienda(idAzienda:string ){
      /* const collectionRef = this.firestore.collection(this.collection_pratiche_scuola).ref;
        this.stats.numeroPraticheScuolaAssegnate          = 0;
        this.stats.numeroPraticheScuolaInCarico           = 0;
        this.stats.numeroPraticheScuolaInProgettazione    = 0;
        this.stats.numeroPraticheScuolaConsegnate         = 0;
        this.stats.numeroPraticheScuolaInRework           = 0;
        this.stats.numeroTotalePraticheScuolaBando1       = 0;
        const queryBando1 = collectionRef
        .where( "idAzienda", "==",  Number.parseInt(idAzienda))
        .where("bando", "==", "BANDO 1");
        onSnapshot(queryBando1, (qs) => {
          qs.forEach((doc) => {
            

            let praticaDaFirestore: PraticaScuola_Firestore = doc.data() as PraticaScuola_Firestore;
            if (praticaDaFirestore.stato==='ASSEGNATA' ) {
              this.stats.numeroPraticheScuolaAssegnate          += 1;
            }else if (praticaDaFirestore.stato==='IN CARICO IMPRESA' ) {
              this.stats.numeroPraticheScuolaInCarico           += 1;
            }else if (praticaDaFirestore.stato==='IN PROGETTAZIONE') {
              this.stats.numeroPraticheScuolaInProgettazione    += 1;
            }else if (praticaDaFirestore.stato==='CONSEGNATA' 
                || praticaDaFirestore.stato==='IN VERIFICA SMARTFIBER' 
                || praticaDaFirestore.stato==='IN CARICO PRESIDIO'
                || praticaDaFirestore.stato==='IN FIRMA VERBALE'
                || praticaDaFirestore.stato==='IN FIRMA PACCHETTO'
                || praticaDaFirestore.stato==='VERBALE FIRMATO'
                || praticaDaFirestore.stato==='FIRMATA'
                || praticaDaFirestore.stato==='PUBBLICATA'
                || praticaDaFirestore.stato==='APPROVATA'
                || praticaDaFirestore.stato==='RESPINTA'
               
              ) {
              this.stats.numeroPraticheScuolaConsegnate         += 1;
            }else if (praticaDaFirestore.stato==='IN REWORK AZIENDA') {
              this.stats.numeroPraticheScuolaInRework           += 1;
            }
            this.stats.numeroTotalePraticheScuolaBando1       += 1;
          });

        }); */
    }
    
    loadStatsBando2PerAzienda(idAzienda:string ){
      /* const collectionRef = this.firestore.collection(this.collection_pratiche_scuola).ref;
      this.stats.numeroPraticheScuolaBando2Assegnate          = 0;
      this.stats.numeroPraticheScuolaBando2InCarico           = 0;
      this.stats.numeroPraticheScuolaBando2InProgettazione    = 0;
      this.stats.numeroPraticheScuolaBando2Consegnate         = 0;
      this.stats.numeroPraticheScuolaBando2InRework           = 0;
      this.stats.numeroTotalePraticheScuolaBando2       = 0;
      const queryBando2 = collectionRef
      .where( "idAzienda", "==",  Number.parseInt(idAzienda))
      .where("bando", "==", "BANDO 2")
      onSnapshot(queryBando2, (qs) => {

        qs.forEach((doc) => {
          let praticaDaFirestore: PraticaScuola_Firestore = doc.data() as PraticaScuola_Firestore;
          if (praticaDaFirestore.stato==='ASSEGNATA' ) {
            this.stats.numeroPraticheScuolaBando2Assegnate        += 1;
            //this.logger.info("---> pratica assegnata ad azienda "+ praticaDaFirestore.codiceInfratel);
          }else if (praticaDaFirestore.stato==='IN CARICO IMPRESA' ) {
            this.stats.numeroPraticheScuolaBando2InCarico         += 1;
          }else if (praticaDaFirestore.stato==='IN PROGETTAZIONE') {
            this.stats.numeroPraticheScuolaBando2InProgettazione   += 1;
          }else if (praticaDaFirestore.stato==='CONSEGNATA' 
                    || praticaDaFirestore.stato==='IN VERIFICA SMARTFIBER' 
                    || praticaDaFirestore.stato==='IN REWORK SMARTFIBER' 
                    || praticaDaFirestore.stato==='IN CARICO PRESIDIO' 
                    || praticaDaFirestore.stato==='IN FIRMA VERBALE' 
                    || praticaDaFirestore.stato==='IN FIRMA PACCHETTO'
                    || praticaDaFirestore.stato==='VERBALE FIRMATO' 
                    || praticaDaFirestore.stato==='FIRMATA' 
                    || praticaDaFirestore.stato==='PUBBLICATA'
                    || praticaDaFirestore.stato==='APPROVATA'
                    || praticaDaFirestore.stato==='RESPINTA'
                  ) {
            this.stats.numeroPraticheScuolaBando2Consegnate   += 1;
          }else if (praticaDaFirestore.stato==='IN REWORK AZIENDA') {
            this.stats.numeroPraticheScuolaBando2InRework           += 1;
          }
          this.stats.numeroTotalePraticheScuolaBando2       += 1;
        });
        
      }); */
    }
    loadStatsSanitaPerAzienda(idAzienda:string ){
      /* const collectionRef = this.firestore.collection(this.collection_pratiche_sanita).ref;
        this.stats.numeroPraticheSanitaAssegnate          = 0;
        this.stats.numeroPraticheSanitaInCarico           = 0;
        this.stats.numeroPraticheSanitaInProgettazione    = 0;
        this.stats.numeroPraticheSanitaConsegnate         = 0;
        this.stats.numeroPraticheSanitaInRework           = 0;
        const queryBando1 = collectionRef
        .where( "idAzienda", "==",  Number.parseInt(idAzienda))
        onSnapshot(queryBando1, (qs) => {
          qs.forEach((doc) => {
            

            let praticaDaFirestore: PraticaSanita_Firestore = doc.data() as PraticaSanita_Firestore;
            if (praticaDaFirestore.stato==='ASSEGNATA' ) {
              this.stats.numeroPraticheSanitaAssegnate          += 1;
            }else if (praticaDaFirestore.stato==='IN CARICO IMPRESA' ) {
              this.stats.numeroPraticheSanitaInCarico           += 1;
            }else if (praticaDaFirestore.stato==='IN PROGETTAZIONE') {
              this.stats.numeroPraticheSanitaInProgettazione    += 1;
            }else if (praticaDaFirestore.stato==='CONSEGNATA') {
              this.stats.numeroPraticheSanitaConsegnate         += 1;
            }else if (praticaDaFirestore.stato==='IN REWORK AZIENDA') {
              this.stats.numeroPraticheSanitaInRework           += 1;
            }
          });

        }); */
    }
    loadStatsPerAzienda(idAzienda:string){
     /*  console.log(' *** loadStatsPerAzienda su collection '+this.collection_pratiche_scuola);
      if(this.hasBando2){
        const collectionRef = this.firestore.collection(this.collection_pratiche_scuola).ref;
        this.stats.numeroPraticheScuolaBando2Assegnate          = 0;
        this.stats.numeroPraticheScuolaBando2InCarico           = 0;
        this.stats.numeroPraticheScuolaBando2InProgettazione    = 0;
        this.stats.numeroPraticheScuolaBando2Consegnate         = 0;
        this.stats.numeroPraticheScuolaBando2InRework           = 0;
        this.stats.numeroTotalePraticheScuolaBando2       = 0;

        const queryBando2 = collectionRef
        .where( "idAzienda", "==",  Number.parseInt(idAzienda))
        .where("bando", "==", "BANDO 2")
        onSnapshot(queryBando2, (qs) => {

          qs.forEach((doc) => {
            let praticaDaFirestore: PraticaScuola_Firestore = doc.data() as PraticaScuola_Firestore;
            if (praticaDaFirestore.stato==='ASSEGNATA' ) {
              
              this.stats.numeroPraticheScuolaBando2Assegnate        += 1;
            }else if (praticaDaFirestore.stato==='IN CARICO IMPRESA' ) {
              this.stats.numeroPraticheScuolaBando2InCarico         += 1;
            }else if (praticaDaFirestore.stato==='IN PROGETTAZIONE') {
              this.stats.numeroPraticheScuolaBando2InProgettazione   += 1;
            }else if (praticaDaFirestore.stato==='CONSEGNATA') {
              this.stats.numeroPraticheScuolaBando2Consegnate   += 1;
            }else if (praticaDaFirestore.stato==='IN REWORK AZIENDA') {
              this.stats.numeroPraticheScuolaBando2InRework           += 1;
            }
            this.stats.numeroTotalePraticheScuolaBando2       += 1;
          });
          
         
          
        });
      }

      if(this.hasBando1){
        const collectionRef = this.firestore.collection(this.collection_pratiche_scuola).ref;
        this.stats.numeroPraticheScuolaAssegnate          = 0;
        this.stats.numeroPraticheScuolaInCarico           = 0;
        this.stats.numeroPraticheScuolaInProgettazione    = 0;
        this.stats.numeroPraticheScuolaConsegnate         = 0;
        this.stats.numeroPraticheScuolaInRework           = 0;
        this.stats.numeroTotalePraticheScuolaBando1       = 0;
        const queryBando1 = collectionRef
        .where( "idAzienda", "==",  Number.parseInt(idAzienda))
        .where("bando", "==", "BANDO 1");
        onSnapshot(queryBando1, (qs) => {
          qs.forEach((doc) => {
            

            let praticaDaFirestore: PraticaScuola_Firestore = doc.data() as PraticaScuola_Firestore;
            if (praticaDaFirestore.stato==='ASSEGNATA' ) {
              this.stats.numeroPraticheScuolaAssegnate          += 1;
            }else if (praticaDaFirestore.stato==='IN CARICO IMPRESA' ) {
              this.stats.numeroPraticheScuolaInCarico           += 1;
            }else if (praticaDaFirestore.stato==='IN PROGETTAZIONE') {
              this.stats.numeroPraticheScuolaInProgettazione    += 1;
            }else if (praticaDaFirestore.stato==='CONSEGNATA') {
              this.stats.numeroPraticheScuolaConsegnate         += 1;
            }else if (praticaDaFirestore.stato==='IN REWORK AZIENDA') {
              this.stats.numeroPraticheScuolaInRework           += 1;
            }
            this.stats.numeroTotalePraticheScuolaBando1       += 1;
          });

        });
      }

      //this.logger.info(">>>> loadStatsPerAzienda "+ this.hasSanita);
      if(this.hasSanita){
        const collectionRef = this.firestore.collection(this.collection_pratiche_sanita).ref;
        this.stats.numeroPraticheSanitaAssegnate          = 0;
        this.stats.numeroPraticheSanitaInCarico           = 0;
        this.stats.numeroPraticheSanitaInProgettazione    = 0;
        this.stats.numeroPraticheSanitaConsegnate         = 0;
        this.stats.numeroPraticheSanitaInRework           = 0;
        const queryBando1 = collectionRef
        .where( "idAzienda", "==",  Number.parseInt(idAzienda))
        onSnapshot(queryBando1, (qs) => {
          qs.forEach((doc) => {
            

            let praticaDaFirestore: PraticaSanita_Firestore = doc.data() as PraticaSanita_Firestore;
            if (praticaDaFirestore.stato==='ASSEGNATA' ) {
              this.stats.numeroPraticheSanitaAssegnate          += 1;
            }else if (praticaDaFirestore.stato==='IN CARICO IMPRESA' ) {
              this.stats.numeroPraticheSanitaInCarico           += 1;
            }else if (praticaDaFirestore.stato==='IN PROGETTAZIONE') {
              this.stats.numeroPraticheSanitaInProgettazione    += 1;
            }else if (praticaDaFirestore.stato==='CONSEGNATA') {
              this.stats.numeroPraticheSanitaConsegnate         += 1;
            }else if (praticaDaFirestore.stato==='IN REWORK AZIENDA') {
              this.stats.numeroPraticheSanitaInRework           += 1;
            }
          });

        });
      } */
    
    }

   
    openAggiornaPraticheBando1(){
      this.csvbox_importer_aggiornaPraticheBando1.openModal();
    }
    openAggiornaPraticheBando2(){
      this.csvbox_importer_aggiornaPratiche.openModal();
    }

    openAggiornaPraticheSanita(){
      this.csvbox_importer_aggiornaPraticheSanita.openModal();
    }

   
    loadStats(){
      /* this.firestore.collection(environment.firebase.collection_stats).valueChanges().subscribe((data) => {
        if (data) {
          this.stats.numeroPraticheSanitaAssegnate  = 0;
          this.stats.numeroPraticheSanitaConsegnate = 0;
          this.stats.numeroPraticheSanitaInProgettazione = 0;
          this.stats.numeroPraticheSanitaInCarico = 0;
          this.stats.numeroPraticheSanitaInRework = 0;

          this.stats.numeroPraticheScuolaAssegnate        = 0;
          this.stats.numeroPraticheScuolaInProgettazione  = 0;
          this.stats.numeroPraticheScuolaConsegnate       = 0;
          this.stats.numeroPraticheScuolaInCarico         = 0;
          this.stats.numeroPraticheScuolaInRework         = 0;

          this.stats.numeroPraticheScuolaValidate         = 0;
          this.stats.numeroPraticheScuolaRespinte        = 0;
          this.stats.numeroPraticheScuolaDaAssegnare      = 0;
          this.stats.numeroPraticheScuolaInCaricoSF       = 0;
          this.stats.numeroPraticheScuolaInCaricoPresidio = 0;
          this.stats.numeroPraticheScuolaInLavorazione    = 0;

          this.stats.numeroPraticheScuolaBando2Validate           = 0;
          this.stats.numeroPraticheScuolaBando2Respinte           = 0;
          this.stats.numeroPraticheScuolaBando2DaAssegnare        = 0;
          this.stats.numeroPraticheScuolaBando2InCaricoSF        = 0;
          this.stats.numeroPraticheScuolaBando2InCaricoPresidio   = 0;
          this.stats.numeroPraticheScuolaBando2InLavorazione      = 0;


          data.forEach(stat =>{
            
            this.stats.numeroPraticheScuolaAssegnate += stat["numeroPraticheScuolaAssegnate"];
            if(stat["numeroPraticheScuolaInProgettazione"]){
              this.stats.numeroPraticheScuolaInProgettazione += stat["numeroPraticheScuolaInProgettazione"];
            }
            
            this.stats.numeroPraticheScuolaConsegnate += stat["numeroPraticheScuolaConsegnate"];
            this.stats.numeroPraticheScuolaInCarico += stat["numeroPraticheScuolaInCarico"];
            this.stats.numeroPraticheScuolaInRework += stat["numeroPraticheScuolaInRework"]; 
           
          });
          this.statsService.hideNotificationBadge = false;
          //this.notificaCambioDatiEvent.emit('I dati sono cambiati!');
          
         
        } else {
          this.logger.error('Le statistiche complessive non sono state trovate');
        }
      }); */
    
    }
   
    openImportBando2(){
      
    }

    openPraticheBando(bando:string, fase:string){
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase/'+fase]));
    }
    openPraticheScuole(stato:string ){
      if(stato){
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-scuola-bando2/stato/'+stato]));
      }else {
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-scuola-bando2']));
      }
    }

    openPraticheScuolaBando2(stato:string ){
      if(stato){
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-scuola-bando2/stato/'+stato]));
      }else {
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-scuola-bando2']));

      }
    }
    openPraticheSanita(stato:string){
      if(stato){
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-sanita/stato/'+stato]));
      }else {
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-sanita']));
      }
    }

    openPianiTecnici(){
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-sanita/piani-tecnici']));
    }

    openPraticheScuolaBando1(stato:string ){
      if(stato){
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-scuola-bando1/stato/'+stato]));
      }else {
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-scuola-bando1']));

      }
    }
   


    getUserInfo() {
     /*  this.dipendenteService
        .getByIdAuth0(localStorage.getItem("userId"))
        .subscribe((res) => {
          //  this.logger.info("--> OTTENGO IL DIPENDENTE DA DB: "+ res.ultimaRegistrazione);
          if (res.ultimaRegistrazione) {
            const formatter = new Intl.DateTimeFormat("it-IT", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            });
            const datavecchia: Date = new Date("2023-06-10");
            this.lastRegistrazione = res.ultimaRegistrazione;
            var oggi: Date = new Date();
            var differenzaMillisecondi = Math.abs(
              this.lastRegistrazione.getTime() - oggi.getTime()
            );
            var differenzaGiorni = Math.ceil(
              differenzaMillisecondi / (1000 * 60 * 60 * 24)
            );

            this.numeroGiorniUltimaRegistrazione = differenzaGiorni;

            this.lastRegistrazioneFormattata = formatter.format(
              new Date(this.lastRegistrazione)
            );
          }
        }); */
    }

    goToRegistro() {
      this.router
        .navigateByUrl("/", { skipLocationChange: true })
        .then(() => this.router.navigate(["/registro"]));
    }

    /* goToRegistroWithMeseDiRiferimento(meseRiferimento: string) {
      this.router
        .navigateByUrl("/", { skipLocationChange: true })
        .then(() =>
          this.router.navigate(["/registro/meseRiferimento=" + meseRiferimento])
        );
    }
    goToRegistroAttivita() {
      this.router
        .navigateByUrl("/", { skipLocationChange: true })
        .then(() => this.router.navigate(["/registro-attivita"]));
    }
    goToDipendenti() {
      this.router
        .navigateByUrl("/", { skipLocationChange: true })
        .then(() => this.router.navigate(["/dipendenti"]));
    }
    goToCommesse() {
      this.router
        .navigateByUrl("/", { skipLocationChange: true })
        .then(() => this.router.navigate(["/commesse"]));
    }
    goToClienti() {
      this.router
        .navigateByUrl("/", { skipLocationChange: true })
        .then(() => this.router.navigate(["/clienti"]));
    } */

    viewBlocks(el: HTMLElement) {
      el.scrollIntoView({ behavior: "smooth" });
    }

    isAdministrator(): boolean {
      return (
        localStorage.getItem("ruolo") === "ADMIN" ||
        localStorage.getItem("ruolo") === "CONTABILE"
      );
    }

    loginWithRedirect() {
      this.auth.loginWithRedirect().subscribe((res) => {});
    }

    /**
     * Metodo per retry automatico delle chiamate API
     */
    private retryApiCall<T>(apiCall: () => Observable<T>, maxRetries: number, delay: number): Observable<T> {
      return apiCall().pipe(
        retry({
          count: maxRetries,
          delay: (error, retryCount) => {
            this.logger.warn(`Tentativo ${retryCount} fallito, riprovo tra ${delay}ms`);
            return timer(delay * retryCount);
          }
        })
      );
    }
}
